const initCustomTabPosts = () => {
    const containers = document.querySelectorAll('.custom-posts-container');
    if (containers.length === 0) return;

    containers.forEach(container => {
        const { articleIds, shopDomain, readMoreText, languageCode } = container.dataset;
        if (!articleIds || !shopDomain || !languageCode) return;

        const formattedIds = articleIds.split(',').map(id => `gid://shopify/Article/${id.trim()}`);
        const storefrontAccessToken = 'a3bbfffa7bd9c12567ca998d55f71454';
        const apiVersion = '2025-10';
        const storefrontApiUrl = `https://${shopDomain}/api/${apiVersion}/graphql.json`;

        const query = `
            query getArticlesByIds($ids: [ID!]!, $language: LanguageCode!) @inContext(language: $language) {
                nodes(ids: $ids) {
                    ... on Article {
                        id
                        title
                        excerpt(truncateAt: 200)
                        onlineStoreUrl
                        image {
                            url
                            altText
                            width
                            height
                        }
                    }
                }
            }
        `;

        const fetchPosts = async () => {
            try {
                const response = await fetch(storefrontApiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                    },
                    body: JSON.stringify({
                        query,
                        variables: {
                            ids: formattedIds,
                            language: languageCode.toUpperCase()
                        },
                    }),
                });

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const { data } = await response.json();
                const articles = data.nodes.filter(Boolean);

                if (articles && articles.length > 0) {
                    const articlesHtml = articles.map(article => {
                        const imageHtml = article.image
                            ? `<div class="custom-tabs-tab-image"><img src="${article.image.url}" alt="${article.image.altText || ''}" width="${article.image.width}" height="${article.image.height}" loading="lazy"></div>`
                            : '';

                        const excerptHtml = article.excerpt
                            ? `<div class="custom-tabs-tab-text">${article.excerpt}</div>`
                            : '';

                        const buttonHtml = `<div class="custom-tabs-tab-button"><a href="${article.onlineStoreUrl}" class="button">${readMoreText}</a></div>`;

                        return `
                            <div class="prose custom-tabs-tab">
                                <div class="custom-tabs-tab-description">
                                    <h3 class="custom-tabs-tab-subtitle">${article.title}</h3>
                                    ${excerptHtml}
                                    ${buttonHtml}
                                </div>
                                ${imageHtml}
                            </div>
                        `;
                    }).join('');

                    container.innerHTML = articlesHtml;
                }

            } catch (error) {
                console.error('Error fetching custom post articles:', error);
                container.innerHTML = '<p>Error loading articles.</p>';
            }
        };

        fetchPosts();
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomTabPosts);
} else {
    initCustomTabPosts();
}
